@switch (columnName) {
  @case ('smsReminder') {
    <mat-icon>{{ element[columnName] ? 'done' : 'close' }}</mat-icon>
  }
  @case ('emailReminder') {
    <mat-icon>{{ element[columnName] ? 'done' : 'close' }}</mat-icon>
  }
  @case ('modules') {
    @for (element of element['moduleNames']; track element) {
      {{ element | translate }}
      <br />
    }
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
}
